<template>
  <Transition name="fade">
    <div
      v-if="isVisible"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="error-title"
    >
      <div
        class="relative w-[90%] max-w-lg rounded-2xl bg-white text-neutral-900 shadow-2xl border border-red-300 p-6"
      >
        <div class="flex items-center gap-3">
          <span
            class="iconify text-red-500 w-6 h-6"
            data-icon="mdi:alert"
          ></span>
          <h2 id="error-title" class="text-lg font-semibold text-red-600">
            {{ title }}
          </h2>
        </div>

        <div
          class="mt-4 bg-red-50 rounded-lg p-4 max-h-64 overflow-auto text-sm"
        >
          <p>{{ message }}</p>
          <p v-if="details" class="mt-2 text-red-700 text-xs">
            {{ details }}
          </p>
        </div>

        <div class="mt-6 flex justify-center">
          <button
            class="px-4 py-2 bg-red-500 text-white rounded-lg shadow hover:bg-red-600 active:bg-red-700 transition"
            @click="handleClose"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useErrorService } from "@/services/ErrorService";

const errorService = useErrorService();
const { isVisible, title, message, details } = storeToRefs(errorService);

function handleClose() {
  errorService.closeAll();
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 180ms ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
